import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { formatPrice } from '@/utils/formatPrice';
import { Box, SelectChangeEvent, Typography } from '@mui/material';
import { ReactNode } from 'react';
import {
	discountPriceSX,
	imageFrameSX,
	imageSX,
	priceRowSX,
	priceSX,
	productCardSX,
	productCategorySX,
	productInfoSX,
	productNameSX,
} from '@/components/blocks/FreeShippingActivatedPopup/styles';
import { FreeShippingSizeSelect } from '@/components/blocks/FreeShippingActivatedPopup/parts/FreeShippingSizeSelect';
import {
	FreeShippingProductHref,
	FreeShippingProductInfo,
} from '@/components/blocks/FreeShippingActivatedPopup/parts/types';

interface FreeShippingProductCardProps {
	productInfo: FreeShippingProductInfo;
	productSelected?: string;
	/** Href al PDP, ya con el query param que marca el add to cart con product_before_payment */
	productHref?: FreeShippingProductHref;
	hideSizeSelect?: boolean;
	onSelectProductSize: (event: SelectChangeEvent<string>) => void;
	onViewProduct?: () => void;
}

export const FreeShippingProductCard = ({
	productInfo,
	productSelected,
	productHref,
	hideSizeSelect,
	onSelectProductSize,
	onViewProduct,
}: FreeShippingProductCardProps) => {
	const discount = productInfo.productPrices.discount
		? formatPrice('es-MX', 'MXN', productInfo.productPrices.discount)
		: undefined;
	const price = formatPrice('es-MX', 'MXN', productInfo.productPrices.price);
	const hasDiscount = Boolean(discount);

	const withProductLink = (children: ReactNode) =>
		productHref ? (
			<Linkable href={productHref} draggable={false} onClick={onViewProduct}>
				{children}
			</Linkable>
		) : (
			children
		);

	return (
		<Box sx={productCardSX}>
			{withProductLink(
				<Box sx={imageFrameSX}>
					<RenderProductImg
						fullImageRaw={productInfo.product.thumbnail}
						render={(src) => (
							<Img src={src} alt={productInfo.product.name} draggable={false} sx={imageSX} />
						)}
					/>
				</Box>
			)}
			<Box sx={productInfoSX}>
				{withProductLink(
					<Typography component="h3" sx={productNameSX}>
						{productInfo.product.name}
					</Typography>
				)}
				<Typography sx={productCategorySX}>{productInfo.productCategory}</Typography>
				<Box sx={priceRowSX}>
					{hideSizeSelect ? null : (
						<FreeShippingSizeSelect
							value={productSelected}
							sizes={productInfo.productSizes}
							onChange={onSelectProductSize}
						/>
					)}
					<Box sx={priceRowSX}>
						{hasDiscount ? <Typography sx={discountPriceSX}>{discount}</Typography> : null}
						<Typography sx={priceSX(hasDiscount)}>{price}</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
